import { CollectionCardLayout } from '@/components/library/CollectionItemCard'

const GRID_BASE_CLASS = 'grid grid-cols-1 gap-x-6 gap-y-10'

const GRID_FOUR_UP_CLASS = `${GRID_BASE_CLASS} @[560px]/collection:grid-cols-2 @[860px]/collection:grid-cols-3 @[1160px]/collection:grid-cols-4`

/**
 * Every resource section stays a small card in a four-up grid, including
 * when the section has one or two items. Topics keep the editorial grid.
 */
const COMPACT_GRID_CLASS =
  'grid grid-cols-1 gap-x-4 gap-y-6 @[520px]/collection:grid-cols-2 @[860px]/collection:grid-cols-3 @[1160px]/collection:grid-cols-4'

export type CollectionSectionDensity = 'editorial' | 'compact'

/**
 * A section's grid for its item count, so a sparse section never leaves
 * most of a row empty: one item takes the full row, two split it, three or
 * more run four up on a wide collection. A compact section always uses the
 * four-up tracks, so one study does not become a full-width hero.
 */
export function collectionSectionGridClass(count: number, density: CollectionSectionDensity = 'editorial'): string {
  if (density === 'compact') {
    return COMPACT_GRID_CLASS
  }
  if (count <= 1) {
    return GRID_BASE_CLASS
  }
  if (count === 2) {
    return `${GRID_BASE_CLASS} @[560px]/collection:grid-cols-2`
  }
  return GRID_FOUR_UP_CLASS
}

/**
 * A card's layout in a section of `count`: the only card is the hero, two
 * are a pair, and the first card leads (two columns wide) when the count
 * leaves one slot spare in the four up rows (3, 7, 11), so the rows close.
 * A compact section is always the regular card.
 */
export function collectionCardLayout(
  index: number,
  count: number,
  density: CollectionSectionDensity = 'editorial',
): CollectionCardLayout {
  if (density === 'compact') {
    return 'standard'
  }
  if (count === 1) {
    return 'hero'
  }
  if (count === 2) {
    return 'pair'
  }
  if (index === 0 && count % 4 === 3) {
    return 'lead'
  }
  return 'standard'
}
